import { render, staticRenderFns } from "./modalLimitededition.vue?vue&type=template&id=edce4cf2"
import script from "./modalLimitededition.vue?vue&type=script&lang=js"
export * from "./modalLimitededition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports